export enum ReportType {
  Null = "null",
  AgedReceivables = "aged-receivables",
  IncomeByCustomer = "income-by-customer",
  IncomeByCategory = "income-by-category",
  SalesTaxReport = "sales-tax-report",
  PaymentsTaxReport = "payments-tax-report",
}
